<template>
  <main class="error-page">
    <section class="error-card qhatu-card">
      <div class="error-icon" aria-hidden="true"><i class="bi bi-compass"></i></div>
      <span class="error-code">404</span>
      <h1>Página no encontrada</h1>
      <p>La dirección ingresada no existe o ya no se encuentra disponible.</p>
      <router-link :to="destino" class="btn btn-primary qhatu-touch-button">
        <i class="bi bi-house-door me-2"></i>Volver al inicio
      </router-link>
    </section>
  </main>
</template>

<script>
export default {
  name: 'QhatuNoEncontrado',
  computed: {
    destino() {
      return localStorage.getItem('access_token') ? '/Home' : '/'
    },
  },
}
</script>

<style scoped>
.error-page { min-height: 100dvh; display: grid; place-items: center; padding: 1rem; background: var(--qhatu-bg); }
.error-card { width: min(100%, 520px); padding: clamp(1.5rem, 5vw, 3rem); text-align: center; }
.error-icon { width: 72px; height: 72px; margin: 0 auto 1rem; border-radius: 22px; display: grid; place-items: center; background: var(--qhatu-primary-soft); color: var(--qhatu-primary); font-size: 2rem; }
.error-code { display: block; color: var(--qhatu-primary); font-size: .78rem; font-weight: 800; letter-spacing: .16em; }
h1 { margin: .45rem 0 .7rem; font-size: clamp(1.6rem, 5vw, 2.25rem); font-weight: 800; }
p { margin: 0 auto 1.5rem; max-width: 390px; color: var(--qhatu-muted); line-height: 1.6; }
</style>
